import React, { useRef, useState } from 'react';
import axios from 'axios';
import './SaveModal.scss';

const SaveModal = ({data, post, close}) => {
    const nameRef = useRef();
    const [error, setError] = useState('')
    const componentToHex = (c) => {
        var hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      }
      const rgbToHex = (r, g, b) => {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
      }

    const handleSave = () => {
        setError('');
        if (!nameRef.current.value) {
            setError('Name required')
            return;
        }
        post["palette_name"] = nameRef.current.value 
        axios.post(`https://blooming-depths-76471.herokuapp.com/add/${post.user_id}`, post)
        // axios.post(`http://localhost:8080/add/${post.user_id}`, post)
        .then(res=>{
            console.log(res)
        })
        close();
    }
    
    return (
        <div className="savemodal">
            <div className="savemodal__content">
                <h2 className="savemodal__title">Save Palette</h2>
                <div className="sv__fill">
                    <div className="savemodal__wrapper">
                        <label className="savemodal__label"htmlFor="">Name</label>
                        <input 
                        placeholder="Palette Name.."
                        className="savemodal__input"
                        type="text"
                        ref={nameRef}/>
                    </div>
                    {error && <p className="sv__error">{error}</p>}
                </div>
                <div className="savemodal__colors">
                    {(data) ? data.map((col, i) => {
                        return <div key={i} className="savemodal__colorbox" style={{background: `${rgbToHex(col[0], col[1], col[2])}`}}/>
                    }) : null}
                </div>
                <div className="savemodal__buttons">
                    <button onClick={close} className="sv__btn sv__btn-cancel">Cancel</button>
                    <button onClick={handleSave} className="sv__btn sv__btn-save">Save</button>
                </div>
            </div>
        </div>
    )
}

export default SaveModal
